import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import {
    GlobalConstants,
    Mail
} from '../classes';

@Injectable({
    providedIn: 'root'
})
export class MailService {

    constructor(private httpClient: HttpClient) { }

    public sendMail(mail: Mail) {
        return this.httpClient.post(`${GlobalConstants.apiURL}/mail/send`, mail);
    }
    
}